import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_ENABLE_LOOKUP_SETTING_BEGIN,
  COLLECTIONS_ENABLE_LOOKUP_SETTING_SUCCESS,
  COLLECTIONS_ENABLE_LOOKUP_SETTING_FAILURE,
  COLLECTIONS_ENABLE_LOOKUP_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function enableLookupSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_ENABLE_LOOKUP_SETTING_BEGIN,
    });
    const { projectId, collectionUuid, finderId, version, enableLookup } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const url = process.env.REACT_APP_BUILDER_ENGINE;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${url}v${version}/finders/${collectionUuid}/collection/${finderId}/enable-lookup`,
        { enableLookup },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_ENABLE_LOOKUP_SETTING_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_ENABLE_LOOKUP_SETTING_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Lookup Enable Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissEnableLookupSettingError() {
  return {
    type: COLLECTIONS_ENABLE_LOOKUP_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_ENABLE_LOOKUP_SETTING_BEGIN:
      return {
        ...state,
        enableLookupSettingPending: true,
        enableLookupSettingError: null,
      };

    case COLLECTIONS_ENABLE_LOOKUP_SETTING_SUCCESS:
      return {
        ...state,
        enableLookupSettingPending: false,
        enableLookupSettingError: null,
      };

    case COLLECTIONS_ENABLE_LOOKUP_SETTING_FAILURE:
      return {
        ...state,
        enableLookupSettingPending: false,
        enableLookupSettingError: action.data.error,
      };

    case COLLECTIONS_ENABLE_LOOKUP_SETTING_DISMISS_ERROR:
      return {
        ...state,
        enableLookupSettingError: null,
      };

    default:
      return state;
  }
}
